import { Injectable } from '@angular/core';
import {  HttpClient, HttpHeaders, HttpResponse, HttpRequest,  HttpParams } from '@angular/common/http';
import { Http, Response, Headers } from '@angular/http';
//import { Observable } from 'rxjs/Observable';
import {Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent, throwError} from 'rxjs';
import 'rxjs/add/operator/map';
import { API_URL } from '../../../utils/constants';
import {Cookie} from 'ng2-cookies';

@Injectable()
export class ValidatorService {
  constructor(private http: Http) { }

  isUsernameRegisterd(username: string) {
    //const headers = new Headers();
    //headers.append('Content-Type', 'application/json');
    //const url = API_URL + 'account/validate/user/' + username;
    const url = API_URL + 'account/validate/user';
    const param = {
      id: 0,
      name: username
    }
    return this.http.post(url, param, { headers: this.getHeaders() })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  isRoleRegisterd(name: string, id: number) {
    const url = API_URL + 'account/validate/role';
    const param = {
      id: id,
      name: name
    }
    return this.http.post(url, param,  { headers: this.getHeaders() })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }


  isClientRegisterd(name: string, id: number) {
    const url = API_URL + 'system/validate/client';
    const param = {
      id: id,
      name: name
    }
    return this.http.post(url, param,  { headers: this.getHeaders() })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  isAppRegisterd(name: string, id: number) {
    const url = API_URL + 'system/validate/app';
    const param = {
      id: id,
      name: name
    }
    return this.http.post(url, param,  { headers: this.getHeaders() })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  private handleError(error: any) {
    console.log(error);
    return Observable.throw(error.json());
  }

  getHeaders(): Headers {
    //const headers = new Headers();
    //headers.append('Content-Type', 'application/json');
    //return headers;
    return new Headers({
      'Content-type': 'application/json',
      'Authorization': 'Bearer ' + Cookie.get('access_token')
    });
  }

 /* getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = Cookie.get('access_token');
    headers = headers.append('Content-Type', 'application/json');
    if (token !== null) {
      headers = headers.append('Authorization', token);
    }
    return headers;
  }*/
}
